import { Box } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { SeasonMapHeader } from "sharedComponents/molecules/SeasonMapHeader";

import { ReactComponent as TicketIconSVG } from "./resource/ticket_icon.svg";

export interface ISeason1MapHeaderProps {
  ticketCount: number;
  isMusicPlaying: boolean;
  handleBack?: () => void;
  handleMusicToggle?: () => void;
}

export const Season1MapHeader: React.FC<ISeason1MapHeaderProps> = ({
  ticketCount,
  handleBack,
  handleMusicToggle,
  isMusicPlaying,
}) => {
  const { t } = useTranslation("map", {
    keyPrefix: "season1.header",
    useSuspense: false,
  });

  // wrapping the SVG box styling is required
  // to make it size correctly inside the header button
  const ticketIcon = (
    <Box display="inline-flex" justifyContent="center" alignItems="center">
      <TicketIconSVG />
    </Box>
  );

  return (
    <SeasonMapHeader
      tokenIcon={ticketIcon}
      tokenCount={ticketCount}
      tokenLabel={t("availableTicketsLabel")}
      handleBack={handleBack}
      isMusicPlaying={isMusicPlaying}
      handleMusicToggle={handleMusicToggle}
    />
  );
};
